<div class="admin-messages-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-8 sm:py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 class="text-3xl sm:text-5xl font-bold mb-2">Messages</h1>
          <p class="text-base sm:text-xl text-blue-100">View and manage all contact messages</p>
        </div>
        <button 
          (click)="goBack()"
          class="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition font-medium flex items-center gap-2 text-sm sm:text-base">
          <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Back
        </button>
      </div>
    </div>
  </section>

  <div class="max-w-7xl mx-auto py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
    <!-- Statistics Cards -->
    <div *ngIf="!loading()" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
      <!-- Total Messages -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-blue-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Total Messages</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ messages().length }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Unanswered -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-yellow-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Unanswered</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ unansweredCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Answered -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-green-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Answered</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ answeredCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Today's Messages -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-purple-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Today</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ todayCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter and Search Bar -->
    <div *ngIf="!loading() && messages().length > 0" class="bg-white rounded-lg shadow-md p-4 sm:p-6 mb-6 space-y-4">
      <!-- Search -->
      <div class="flex flex-col sm:flex-row gap-4">
        <div class="flex-1">
          <div class="relative">
            <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <input 
              type="text"
              [(ngModel)]="searchQuery"
              placeholder="Search by name, email, or subject..."
              class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-gray-50">
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="flex flex-wrap items-center gap-3">
        <button
          (click)="filterStatus.set('all')"
          [class.bg-immovea-navy]="filterStatus() === 'all'"
          [class.text-white]="filterStatus() === 'all'"
          [class.bg-gray-100]="filterStatus() !== 'all'"
          [class.text-gray-700]="filterStatus() !== 'all'"
          class="px-4 py-2 rounded-lg font-medium transition text-sm">
          All ({{ messages().length }})
        </button>
        <button
          (click)="filterStatus.set('unanswered')"
          [class.bg-yellow-600]="filterStatus() === 'unanswered'"
          [class.text-white]="filterStatus() === 'unanswered'"
          [class.bg-gray-100]="filterStatus() !== 'unanswered'"
          [class.text-gray-700]="filterStatus() !== 'unanswered'"
          class="px-4 py-2 rounded-lg font-medium transition text-sm">
          Unanswered ({{ unansweredCount }})
        </button>
        <button
          (click)="filterStatus.set('answered')"
          [class.bg-green-600]="filterStatus() === 'answered'"
          [class.text-white]="filterStatus() === 'answered'"
          [class.bg-gray-100]="filterStatus() !== 'answered'"
          [class.text-gray-700]="filterStatus() !== 'answered'"
          class="px-4 py-2 rounded-lg font-medium transition text-sm">
          Answered ({{ answeredCount }})
        </button>
      </div>

      <!-- Results Summary -->
      <div class="text-sm text-gray-600 pt-2 border-t">
        Showing <span class="font-semibold text-gray-900">{{ filteredMessages.length }}</span> of <span class="font-semibold text-gray-900">{{ messages().length }}</span> messages
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading()" class="space-y-4">
      <div *ngFor="let i of [1,2,3,4]" class="bg-white rounded-xl shadow-md p-6 animate-pulse">
        <div class="flex items-start gap-4">
          <div class="w-12 h-12 bg-gray-200 rounded-lg"></div>
          <div class="flex-1 space-y-3">
            <div class="h-4 bg-gray-200 rounded w-1/4"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2"></div>
            <div class="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading() && messages().length === 0" class="bg-white rounded-xl shadow-lg py-20 px-8">
      <div class="max-w-md mx-auto text-center">
        <!-- Icon -->
        <div class="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-full flex items-center justify-center">
          <svg class="w-10 h-10 sm:w-12 sm:h-12 text-immovea-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
        </div>
        
        <!-- Message -->
        <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-3">No Messages Yet</h3>
        <p class="text-gray-600 mb-4 leading-relaxed">Your inbox is empty. When customers reach out through the contact form, their messages will appear here.</p>
        <p class="text-sm text-gray-500">💬 Stay tuned for incoming inquiries!</p>
      </div>
    </div>

    <!-- Messages Cards -->
    <div *ngIf="!loading() && filteredMessages.length > 0" class="space-y-4">
      <div *ngFor="let message of filteredMessages" 
           class="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border-l-4"
           [class.border-yellow-500]="!message.is_answered"
           [class.border-green-500]="message.is_answered">
        <div class="p-4 sm:p-6">
          <div class="flex flex-col lg:flex-row lg:items-start gap-4">
            <!-- Avatar/Icon -->
            <div class="flex-shrink-0">
              <div class="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold text-lg"
                   [class.bg-yellow-500]="!message.is_answered"
                   [class.bg-green-500]="message.is_answered">
                {{ getInitials(message.name) }}
              </div>
            </div>

            <!-- Content -->
            <div class="flex-1 min-w-0">
              <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-3">
                <div class="flex-1">
                  <h3 class="text-lg font-bold text-gray-900">{{ getEscapedField(message.name) }}</h3>
                  <p class="text-sm text-gray-600">{{ getEscapedField(message.email) }}</p>
                </div>
                <div class="flex items-center gap-2">
                  <button 
                    (click)="toggleMessageStatus(message)"
                    [class.bg-green-100]="message.is_answered"
                    [class.bg-yellow-100]="!message.is_answered"
                    [class.text-green-800]="message.is_answered"
                    [class.text-yellow-800]="!message.is_answered"
                    class="px-3 py-1.5 rounded-full text-xs font-semibold transition-colors cursor-pointer hover:opacity-80 flex items-center gap-1.5 whitespace-nowrap">
                    <span class="w-2 h-2 rounded-full"
                          [class.bg-green-500]="message.is_answered"
                          [class.bg-yellow-500]="!message.is_answered"></span>
                    {{ message.is_answered ? 'Answered' : 'Unanswered' }}
                  </button>
                </div>
              </div>

              <div class="space-y-2 mb-4">
                <div class="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                  <div class="flex items-center gap-1.5">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                    {{ getEscapedField(message.country_code) }} {{ getEscapedField(message.phone) }}
                  </div>
                  <div class="flex items-center gap-1.5">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                    {{ message.created_at | date: 'medium' }}
                  </div>
                </div>

                <div>
                  <p class="text-sm font-semibold text-gray-800 mb-1">Subject:</p>
                  <p class="text-sm text-gray-700">{{ getEscapedField(message.subject) }}</p>
                </div>

                <div>
                  <p class="text-sm font-semibold text-gray-800 mb-1">Message:</p>
                  <p class="text-sm text-gray-700 line-clamp-2">{{ getEscapedField(message.message) }}</p>
                </div>
              </div>

              <!-- Actions -->
              <div class="flex flex-wrap items-center gap-2 sm:gap-3">
                <button
                  (click)="openDetails(message)"
                  class="flex-1 sm:flex-none bg-immovea-navy text-white px-4 py-2 rounded-lg hover:bg-blue-900 transition font-medium text-sm flex items-center justify-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                  View Details
                </button>
                <a
                  [href]="'mailto:' + message.email"
                  class="flex-1 sm:flex-none bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition font-medium text-sm flex items-center justify-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                  Reply
                </a>
                <button
                  (click)="deleteMessage(message)"
                  [disabled]="deleting()"
                  class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results State -->
    <div *ngIf="!loading() && messages().length > 0 && filteredMessages.length === 0" class="bg-white rounded-xl shadow-lg py-16 px-8">
      <div class="max-w-md mx-auto text-center">
        <div class="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900 mb-2">No messages found</h3>
        <p class="text-gray-600">Try adjusting your search or filters</p>
      </div>
    </div>
  </div>
</div>

<!-- Details Modal -->
<div *ngIf="showDetailsModal()" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
  <div class="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" *ngIf="selectedMessage() as message">
    <!-- Modal Header -->
    <div class="sticky top-0 bg-gradient-to-r from-immovea-navy to-blue-700 text-white px-6 py-4 flex justify-between items-center rounded-t-xl">
      <h3 class="text-xl font-bold">Message Details</h3>
      <button
        (click)="closeModal()"
        class="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="px-6 py-6 space-y-6">
      <!-- Sender Info Card -->
      <div class="bg-blue-50 rounded-xl p-4 border border-blue-200">
        <div class="flex items-start gap-4">
          <div class="w-14 h-14 rounded-lg flex items-center justify-center text-white font-bold text-xl"
               [class.bg-yellow-500]="!message.is_answered"
               [class.bg-green-500]="message.is_answered">
            {{ getInitials(message.name) }}
          </div>
          <div class="flex-1">
            <h4 class="text-lg font-bold text-gray-900">{{ getEscapedField(message.name) }}</h4>
            <div class="mt-2 space-y-1 text-sm text-gray-700">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <a [href]="'mailto:' + message.email" class="hover:text-blue-600">{{ getEscapedField(message.email) }}</a>
              </div>
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                <a [href]="'tel:' + message.country_code + message.phone" class="hover:text-blue-600">
                  {{ getEscapedField(message.country_code) }} {{ getEscapedField(message.phone) }}
                </a>
              </div>
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                {{ message.created_at | date: 'full' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Subject -->
      <div>
        <label class="block text-sm font-bold text-gray-700 mb-2">Subject</label>
        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-900">{{ getEscapedField(message.subject) }}</p>
        </div>
      </div>

      <!-- Message Content -->
      <div>
        <label class="block text-sm font-bold text-gray-700 mb-2">Message</label>
        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200 whitespace-pre-wrap max-h-64 overflow-y-auto">
          <p class="text-gray-900 leading-relaxed">{{ getEscapedField(message.message) }}</p>
        </div>
      </div>

      <!-- Admin Notes -->
      <div>
        <label class="block text-sm font-bold text-gray-700 mb-2">Admin Notes</label>
        <textarea
          [(ngModel)]="adminNotes"
          rows="4"
          placeholder="Add internal notes about this message..."
          class="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-immovea-navy focus:border-transparent outline-none bg-gray-50"
        ></textarea>
        <button
          (click)="saveAdminNotes()"
          class="mt-3 bg-purple-600 text-white px-5 py-2 rounded-lg hover:bg-purple-700 transition text-sm font-medium flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"></path>
          </svg>
          Save Notes
        </button>
      </div>

      <!-- Status Toggle -->
      <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            [checked]="message.is_answered"
            (change)="toggleMessageStatus(message)"
            class="w-5 h-5 rounded border-gray-300 text-immovea-navy focus:ring-2 focus:ring-immovea-navy cursor-pointer"
          />
          <div>
            <span class="text-sm font-bold text-gray-900">Mark as Answered</span>
            <p class="text-xs text-gray-600">Toggle to track if you've responded to this message</p>
          </div>
        </label>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex flex-wrap justify-between gap-3 rounded-b-xl">
      <button
        (click)="deleteMessage(message)"
        [disabled]="deleting()"
        class="bg-red-600 text-white px-5 py-2.5 rounded-lg hover:bg-red-700 transition text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
        </svg>
        {{ deleting() ? 'Deleting...' : 'Delete Message' }}
      </button>
      <button
        (click)="closeModal()"
        [disabled]="deleting()"
        class="bg-gray-600 text-white px-5 py-2.5 rounded-lg hover:bg-gray-700 transition text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed">
        Close
      </button>
    </div>
  </div>
</div>
